// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container___2FBYm","button":"styles__button___3aBaa","modal":"styles__modal___qxJua","overlay":"styles__overlay___3Pcli"};


//////////////////
// WEBPACK FOOTER
// ./src/views/collaborate/queue-panel/styles.css
// module id = 1095
// module chunks = 0